import atlasLightLogo from "../assets/sjLogos/sj-logo-atlas-light.svg";
import atlasDarkLogo from "../assets/sjLogos/sj-logo-atlas-dark.svg";
import atlasLightIcon from "../assets/sjLogos/sj-icon-atlas-light.svg";
import atlasDarkIcon from "../assets/sjLogos/sj-icon-atlas-dark.svg";

export type ThemeName = "atlas-light" | "atlas-dark" | "system";

export interface IThemeConfig {
  name: ThemeName;
  cssPath: string;
  displayName: string;
  logo: string;
  /** Compact icon only Logo. */
  iconLogo: string;
}

export type ThemeList = Record<Exclude<ThemeName, "system">, IThemeConfig>;

export const THEMES: ThemeList = {
  "atlas-light": {
    name: "atlas-light",
    cssPath: "/themes/atlas-light-theme.css",
    displayName: "Atlas Light",
    logo: atlasLightLogo,
    iconLogo: atlasLightIcon,
  },
  "atlas-dark": {
    name: "atlas-dark",
    cssPath: "/themes/atlas-dark-theme.css",
    displayName: "Atlas Dark",
    logo: atlasDarkLogo,
    iconLogo: atlasDarkIcon,
  },
};

export const THEME_NAMES = Object.keys(THEMES) as ThemeName[];
export const DEFAULT_THEME = "atlas-light" satisfies keyof typeof THEMES;
